import React from 'react';
import { MIN_QUANTITY } from '../../constants/orderFormConstants';

const QuantityInput = ({ quantity, price, handleQuantityChange }) => {
  return (
    <div>
      <label className="text-black font-medium">
        Quantity <span style={{ color: "red" }}>(min:{MIN_QUANTITY})</span>
      </label>
      <div className="flex items-center ">
        <input
          className=" bg-white text-gray-900 border border-gray-400 mt-2 p-3 rounded-2xl hover:border-black focus:outline-none focus:shadow-outline"
          type="number"
          placeholder=""
          value={quantity}
          onChange={handleQuantityChange}
        />
        {quantity && (
          <div className="text-gray-600 ml-4 overflow-auto md:overflow-visible lg:overflow-visible  lg:flex-none lg:max-w-[20rem]">
            Price:{" "}
            <span style={{ color: "green" }}>{price}$</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuantityInput;
